<div
  [ngClass]="['dropdown-container', 'h-100', !!customClass ? customClass : '']"
  [isDisabled]="isDisabled"
  [dropup]="isDropup"
  dropdown
  (isOpenChange)="isOpen($event)"
>
  <button
    *ngIf="!modeHorizontal; else modeHorizontalTemplate"
    class="btn h-100"
    dropdownToggle
    type="button"
    [class.disabled]="isDisabled"
    [disabled]="isDisabled"
    [class.dropdown-visible-container]="newStyle"
    [class.btn-sm]="!largeButton && btnClass"
    [class.btn-light]="(!input.value || dicoValues[input.value]) && (!showErrors || !input.invalid) && btnClass"
    [class.btn-danger]="((input.value && !dicoValues[input.value]) || (input.invalid && showErrors)) && btnClass"
    [attr.id]="'dropdown-' + id"
    [attr.aria-controls]="'dropdown-list-' + id"
    [attr.title]="dicoValues[input.value] || 'Unknown'"
    [ngClass]="{ fullWidth: fullWidth }"
    #dropdownContent
  >
    <span
      class="dropdown-visible-content text center"
      *ngIf="input.value"
      [innerHTML]="dicoValues[input.value] || 'Unknown'"
      [style.font-size]="textSize"
    >
    </span>
    <span class="dropdown-visible-content center" *ngIf="!input.value">CHOOSE...</span>

    <!-- Caret down -->
    <span class="flex-shrink-0 m-2">
      <i class="fas fa-chevron-down"></i>
    </span>
  </button>

  <ng-template #modeHorizontalTemplate>
    <div class="horizontal">
      <div
        *ngFor="let value of values"
        class="item"
        [ngClass]="value"
        [class.colors]="isTypeDataKey"
        [class.scope]="isScope"
        [class.active]="input.value === value"
        [attr.title]="dicoValues[value] || ''"
        (click)="select(value)"
        [innerHTML]="dicoValues[value]"
        (mouseenter)="hoverAction(dicoValues[value])"
      >
        {{ input.value }}
      </div>
    </div>
  </ng-template>

  <div class="mt-3 d-flex p-0 align-items-center" *ngIf="add && isAddingNewItem">
    <input
      class="form-control mr-2"
      [placeholder]="protocolDroidService.translate('shared.components.node-list.add-category')"
      type="text"
      [(ngModel)]="newItem"
    />
    <span class="input-icon"><i class="fas fa-check" (click)="addNewItem()"></i></span>
    <span class="input-icon"><i class="fas fa-times text-danger" (click)="addNewItem(true)"></i></span>
  </div>
  <ul
    class="dropdown-menu ideta-scrollbar scrollbar-small"
    [class.dropup-menu]="isDropup"
    [attr.id]="'dropdown-list-' + id"
    *dropdownMenu
    role="menu"
    [attr.aria-labelledby]="'dropdown-' + id"
  >
    <li role="menuitem py-2">
      <div class="btn btn-sm btn-outline-secondary dropdown-btn w-100" *ngIf="add && !isAddingNewItem">
        <div
          class="dropdown-visible-content add-item-cta"
          (click)="isAddingNewItem = true"
          appProtocolDroid="shared.ui-elements.simple-dropdown.add-item"
        >
          <i class="fas fa-plus"></i> Ajouter une catégorie
        </div>
      </div>
    </li>
    <li class="dropdown-item disabled" role="menuitem" *ngIf="!values.length" appProtocolDroid="shared.ui-elements.simple-dropdown.empty">
      <i>Vide...</i>
    </li>
    <li
      class="dropdown-item"
      role="menuitem"
      *ngFor="let value of values"
      [class.selected]="input.value === value && highlightSelectedItem"
      [attr.title]="dicoValues[value] || ''"
      (click)="select(value)"
      [innerHTML]="dicoValues[value]"
      (mouseenter)="hoverAction(dicoValues[value])"
    ></li>
  </ul>
</div>
